import { InjectionToken } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { NativeRecordStrategy } from './strategies/native-record.strategy';
import { WebRecordStrategy } from './strategies/web-record.strategy';
import { RecordStrategy } from './interfaces/record-strategy.interface';

export const RECORD_STRATEGY = new InjectionToken<RecordStrategy>('RecordStrategy');

export const RECORD_MEDIA_SERVICE_PROVIDER = {
  provide: RECORD_STRATEGY,
  useClass: Capacitor.isNativePlatform()
    ? NativeRecordStrategy
    : WebRecordStrategy,
};
